var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("CompassDialog", {
    staticClass: "popup-checksendingmail",
    attrs: {
      visible: _vm.showModal,
      size: "small",
      title: _vm.popupTitle,
      closeOnClickOverlay: false
    },
    on: {
      "update:visible": function($event) {
        _vm.showModal = $event
      },
      closed: function($event) {
        return _vm.$emit("close")
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c("p", [_vm._v(_vm._s(_vm.popupMessage))]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-3" },
                  [
                    _c(
                      "CompassFormItem",
                      {
                        attrs: {
                          label: _vm.popupInputLabel,
                          error: _vm.errorMessage,
                          disabled: _vm.mode !== "edit"
                        }
                      },
                      [
                        _c("CompassInput", {
                          ref: "popupCheckSendingEmailInput",
                          staticClass: "wp-10",
                          attrs: {
                            disabled: _vm.mode !== "edit",
                            readonly: false,
                            placeholder: _vm.$t.__("common.labels.email"),
                            error: _vm.isEmailError
                          },
                          model: {
                            value: _vm.email,
                            callback: function($$v) {
                              _vm.email = $$v
                            },
                            expression: "email"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("CompassAlert", {
                  staticClass: "mb-0 mt-3",
                  attrs: {
                    description: _vm.$t.__(
                      "popups.PopupCheckSendingEmail.click_email_link"
                    ),
                    showClose: false
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer",
        fn: function() {
          return [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.cancel"),
                    type: "secondary"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$emit("close")
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  ref: "buttonSendValidationEmail",
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.popupSubmitButtonLabel,
                    disabled: _vm.isEmailError
                  },
                  on: {
                    click: function($event) {
                      return _vm.onSubmit()
                    }
                  }
                })
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }